import { jsxs, jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Image } from "@zillow/constellation-10";
import { Upsell, withPreload } from "@zillow/zrs-cms";
import React from "react";
import StructuredData from "../../components/StructuredData/StructuredData.esm.js";
const ImagePreload = withPreload(Image);
const fullHeightClass = css({
  height: "100%"
});
const BlockUpsell = ({
  attrs: {
    button = "Learn More",
    body,
    color = "blue",
    heading,
    id,
    image,
    legal,
    size = "xs",
    url
  }
}) => /* @__PURE__ */ jsxs(React.Fragment, { children: [
  image && /* @__PURE__ */ jsx(StructuredData, { data: {
    "@context": "https://schema.org/",
    "@type": "ImageObject",
    contentUrl: image.src,
    caption: image.alt,
    height: image.height,
    width: image.width
  } }),
  /* @__PURE__ */ jsx(Upsell, { body, button, className: fullHeightClass, color, heading, id, image: image ? /* @__PURE__ */ jsx(ImagePreload, { src: image.src, width: image.width, height: image.height, alt: image.alt, decoding: image.decoding, loading: "lazy" }) : void 0, legal, size, url })
] });
export {
  BlockUpsell as default
};
